
    

  


    <div class="card-body">

        <div class="row no-margin">
           
            <div class="col-12 annualCost">Annual Fee </div>
            
            <div  class="col-8 labelHd"><span >OLD: </span> <span class="plateName">{{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.oldAltText || "Unknown"}}</span></div>
            <div   class="col-4 tagAmmount" >
                {{(dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.oldAnnualFee? dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.oldAnnualFee:0) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
            </div>
            <div  class="col-6 col-sm-4 pl-5">
                <div class="1">
                    <div class="card-img plateImage"
                        *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.oldImageCode">
                        <img src="{{globalService.externalResourcesUrl}}dmv/{{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.oldImageCode}}.jpg"
                            class="img-fluid"
                           >
                    </div>
                    <div class="card-img plateImage"
                        *ngIf="!dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.oldImageCode">
                        <span class="noTag noTagBig">
                           <span class="noTagText"> Plate Style Image Not Available</span>
                        </span>
                    </div>
                </div>
            </div>
            <div  class="col-6 col-sm-8"></div>

            <div  class="col-8 labelHd"><span>NEW: </span> <span class="plateName">{{newAltText || "Unknown"}}</span></div>
            <div   class="col-4 tagAmmount">
                {{(dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.annualFee? dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.annualFee:0) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
            </div>
            <div  class="col-6 col-sm-4 pl-5">
                <div class="1">
                    <div class="card-img plateImage"
                        *ngIf="newImageCode">
                        <img src="{{globalService.externalResourcesUrl}}dmv/{{newImageCode}}.jpg"
                            class="img-fluid"
                           >
                    </div>
                    <div class="card-img plateImage"
                        *ngIf="!newImageCode">
                        <span class="noTag noTagBig">
                           <span class="noTagText"> Plate Style Image Not Available</span>
                        </span>
                    </div>
                </div>
            </div>
            <div  class="col-6 col-sm-8"></div>
            <div  class="col-12 plateChangeHd mt-4">Cost Breakdown</div>
            <div  class="col-8 labelHd">Net change in annual fee  <span 
                *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.availableRenewalOptions?.length>0">
                (for {{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.selectedRenewalOption}} year{{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.selectedRenewalOption>1?'s':''}})</span>:</div>
            <div   class="col-4 tagAmmount">
                {{(plateStyleNetChange? plateStyleNetChange:0) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
            </div>


            <div *ngIf="plateStyleProcessingCost" class="col-8 labelHd">Processing fee  <span 
                *ngIf="dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.registration?.availableRenewalOptions?.length>0">
                (for {{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.selectedRenewalOption}} year{{dmvStoreService.registrationsInCart?.dmvRegistrations[registrationNumber]?.selectedRenewalOption>1?'s':''}})</span>:</div>
            <div *ngIf="plateStyleProcessingCost"   class="col-4 tagAmmount">
                {{(plateStyleProcessingCost? plateStyleProcessingCost:0) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
            </div>



            <div  class="col-8 labelHd">One-time plate replacement fee:</div>
            <div   class="col-4 tagAmmount">
                {{(plateStyleRepLacementFee? plateStyleRepLacementFee:0) | currency :'USD':'symbol':'1.2-2'  | minusSignToParens}}
            </div>

            <div class="col-12 row no-margin no-padding totalTxt">
                <div class="col-6 labelHd totalHd">TOTAL</div>
                <div class="col-6 tagAmmount total" >{{
                        newPlateStyleCost | currency :'USD':'symbol':'1.2-2'  | minusSignToParens
                    }}</div>
            </div>
        </div>

      
    </div>
